module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/installmentconfig/installmentconfig.component.css
// module id = ./src/app/allocation/installmentconfig/installmentconfig.component.css
// module chunks = main